<template>
  <div>
    <q-layout view="hHh Lpr lff" container style="height: 100vh;" class="shadow-2">
      <q-header elevated :class="$q.dark.isActive ? 'bg-secondary' : 'bg-primary'">
        <q-toolbar>
          <q-btn flat @click="drawer = !drawer" round dense icon="menu" />
          <q-item :to="{ name: 'signIn' }" class="row justify-center">
            <img src="../../assets/sacraLogo.png" class="logo-header">
            <q-toolbar-title>Serviço Social</q-toolbar-title>
          </q-item>
        </q-toolbar>
      </q-header>

      <q-drawer v-model="drawer" show-if-above :mini="miniState" @mouseenter="miniState = false"
        @mouseleave="miniState = true" :width="200" :breakpoint="500" bordered
        :class="$q.dark.isActive ? 'bg-grey-9' : 'bg-grey-3'">
        <q-scroll-area class="fit" :horizontal-thumb-style="{ opacity: 0 }">
          <q-list padding>
            <q-item clickable v-ripple :to="{ name: 'configUser' }">
              <q-item-section avatar>
                <q-avatar>
                  <img v-if="user.avatar !=='EMPTY AVATAR'" :src="user.avatar">
                  <q-icon v-if="user.avatar==='EMPTY AVATAR'" name="account_circle" size="40px"></q-icon>
                </q-avatar>
              </q-item-section>

              <q-item-section>
                {{ user.name }}
              </q-item-section>
            </q-item>

            <q-item clickable v-ripple :to="{ name: 'registration' }">
              <q-item-section avatar>
                <q-icon name="person_add" />
              </q-item-section>

              <q-item-section>
                novo registro
              </q-item-section>
            </q-item>

            <q-item clickable v-ripple :to="{ name: 'findRegistration' }">
              <q-item-section avatar>
                <q-icon name="view_list" />
              </q-item-section>

              <q-item-section>
                Lista de registro
              </q-item-section>
            </q-item>

            <q-item v-if="user.nivel === 'adminstrador(a)'" clickable v-ripple :to="{ name: 'panelAdmin' }">
              <q-item-section avatar>
                <q-icon name="admin_panel_settings" />
              </q-item-section>

              <q-item-section>
                painel administrador
              </q-item-section>
            </q-item>
            <q-item clickable v-ripple @click="logout">
              <q-item-section avatar>
                <q-icon name="logout" />
              </q-item-section>

              <q-item-section>
                sair
              </q-item-section>
            </q-item>
          </q-list>
        </q-scroll-area>
      </q-drawer>

      <q-page-container>
        <q-page padding class="content">
          <slot />
        </q-page>
      </q-page-container>
    </q-layout>
  </div>
</template>
<script>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  setup() {
    const store = useStore()
    const user = computed(() => store.getters.getUser)
    const route = useRouter()
    async function logout() {
      localStorage.clear()
      route.push('/')
      window.location.reload()
    }
    return {
      drawer: ref(false),
      miniState: ref(true),
      user,
      logout
    }
  }
}
</script>
<style lang="css" scoped>
.content {
  background-color: rgb(209, 209, 214);
}

.logo-header {
  height: 20px;
  margin-top: 5px;
}
</style>